export function useAutoScrollTop() {
  onMounted(() => {
    document.querySelector('#scroll-container')?.scrollTo(0, 0)
  })
}
